export const uk = {
    category: 'Категории',
    selected: 'Выбранные',
    zones: 'Зоны'
};
